import type { movementType } from './types'
import movementTypeData from '../../data/movementTypeData.json'

export class movementTypeService {
  async getMovementTypeList(): Promise<{ data: movementType[] }> {
    const movementTypeList = movementTypeData.data
    return { data: movementTypeList }
  }
}

